<div class="container">
    <div class="pendingUpdateIcon" libTooltip [tooltip]="tooltip">
        <div class="icon" [innerHTML]="pendingUpdateIcon"></div>
    </div>
    <div class="companyInfo">
        <span>{{ text }}</span>
    </div>
</div>
